<template>
    <div class="venueVue">
        <div class="o-main-content-area">
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row">
                    <div class="col-md-8">
                        <h1 class="h1">Venue</h1>
                    </div>
                    <div class="col-md-4 text-right">
                        <ul class="o-filter-area">
                            <li class="o-search-field">
                                <div class="input-group stylish-input-group">
                                    <input v-on:keyup="getVenueList()" v-model="searchData" type="text" class="form-control" placeholder="Search">
                                    <span class="input-group-addon">
                                        <button type="submit">
                                        <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                    </button>
                                    </span>
                                </div>
                            </li>
                            <li 
                                v-if="getPower('addVenue')"><a href="javascript: void(0)" 
                                @click="addVenueAddress()" class="c-common-btn c-common-btn--green">
                                <i class="fa fa-plus" aria-hidden="true"></i> 
                                Add Venue</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="o-ndividualArea c-responsive-fixwidth" v-loading="loading">
            <div 
                class="o-ndividualTable"                  
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10"
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
                style="min-height: 1px;"
            >
                <div class="row">
                    <div class="col-sm-6" v-for="(venue,index) in venues" :key="index" v-if="venue.addresses&&venue.addresses.length!=0">
                        <div class="o-custom-table-container c-common-box-shadow c-radius3 venue-small-table">
                            <div class="o-calls-table c-common-gradient o-overflow-visible">
                                <div class="calls-table-row phonesheet-table-row">

                                    <div class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Location Name:</span>
                                                    <div>{{venue.name}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <div class="address-header">
                                                        <span>Address:</span> 
                                                        <span v-if="(userRoleSlug==''||userRoleSlug=='employer-admin')&&venue.favourite">
                                                            <a href="javascript: void(0)" @click="removeVenueFromEmployerFavorite(venue.id)" class="venue-remove">   
                                                                Remove from Favorite
                                                            </a>
                                                        </span>
                                                        <span v-if="(userRoleSlug==''||userRoleSlug=='employer-admin')&&!venue.favourite">
                                                            <a href="javascript: void(0)" @click="addVenueToEmployerFavorite(venue.id)" class="venue-add">
                                                                Add to Favorite
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div 
                                                        v-if="venue.addresses&&venue.addresses.length">
                                                        {{venue.addresses[0].address}}, 
                                                        {{venue.addresses[0].state_province}}, 
                                                        {{venue.addresses[0].postcode}} 
                                                        {{", " +venue.addresses[0].country}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calls-table-cell">
                                        <div>
                                            <div class="o-accordion-subtext text-center">
                                                <span>Verified?</span>
                                                <span 
                                                    :class="(venue.addresses[0].status && venue.addresses[0].status ==1) ? 
                                                    'c-common-btn--inverse-icon-green':'c-common-btn--inverse-icon-orange'"
                                                >
                                                    <i 
                                                        :class="(venue.addresses[0].status && venue.addresses[0].status ==1) ? 
                                                        'fa fa-check' : 'fa fa-exclamation-triangle'" aria-hidden="true">
                                                    </i>
                                                </span>

                                            </div>
                                            
                                            <div class="o-accordion-subtext text-center" 
                                                v-if="(venue.addresses[0].status && venue.addresses[0].status ==1)"
                                            >
                                                <span 
                                                    v-if="(getPower('addJob')||getAddJobPower())&&(userRoleSlug=='employer'||userRoleSlug=='employer-admin')">
                                                    <a href="javascript: void(0)" @click="openAddJob(venue)" 
                                                    class="c-common-btn c-common-btn2 c-common-btn--green font-plain">
                                                        Add Job
                                                    </a>
                                                </span> 

                                                <span 
                                                    v-else-if="getPower('addJob')||getAddJobPower()">
                                                    <a href="javascript: void(0)" @click="addJobModal(venue)" 
                                                    class="c-common-btn c-common-btn2 c-common-btn--green font-plain">
                                                        Add Job
                                                    </a>
                                                </span>                  
                                            </div>
                                        </div>
                                    </div>

                                    <div class="calls-table-cell text-center o-no-padding">
                                        <div class="o-edit-trash o-no-padding">

                                            <div class="o-table-block-btn">
                                                <a :class="{'disabled':!getPower('editVenue')}" 
                                                    href="javascript: void(0)" 
                                                    @click="editVenueAddress(venue)">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                            <div class="o-table-block-btn">
                                                <a :class="{'disabled':!getPower('deleteVenue')}" 
                                                href="javascript: void(0)" 
                                                @click="deleteVenueSingle(venue.id)">
                                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                            </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="venues.length <= 0 && afterApi" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                       <div class="col-md-12 no-job-dispaly">
                          <i class="fa fa-frown-o" aria-hidden="true"></i>
                          <br />
                           No Data Stored
                       </div>
                    </div>
                </div>
            </div>
        </div>

        <modal name="add-employer-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom" width="40%">
            <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button type="button" 
                                @click="closeAddJob()" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" 
                                aria-label="Close">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">{{modalType=='add'?'Add New Job':'Edit Job'}}</h1>
                        </div>

                        <div v-loading="modalDataLoad" class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Event Name:<span class="req-text">*</span></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                            <input v-model="addJob.title" v-validate="'required'" name="event name" type="text" class="form-control" placeholder="Event Name">
                                            <span class="err-msg">{{ errors.first('event name') }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Client:<span class="req-text">*</span></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <div class="row">
                                            <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                                <div class="common-label-input--modalwidth o-custom-dropdown">
                                                    <select 
                                                        v-validate="'required'" 
                                                        name="client" 
                                                        class="form-control" v-model="addJob.client" 
                                                        :disabled="modalType=='edit'" 
                                                        @change="getDropdownVenues()"
                                                    >
                                                        <option value="">--- Select ---</option>
                                                        <option 
                                                            v-for="(client,clientIndex) in clients" :key="clientIndex" 
                                                            :value="client.client_id" 
                                                            :class="client.can_create_job === true ? '':'disabled-background-style'" 
                                                            :disabled="client.can_create_job !== true">
                                                            {{client.client.subdomain.toUpperCase()}}
                                                        </option>
                                                    </select>

                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    <span class="err-msg">{{ errors.first('client') }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                            </div>
                                            <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                <div class="common-label-input--modalwidth o-custom-dropdown">
                                                    <select class="form-control" v-model="addJob.payroll">
                                                        <option value="">--- Select ---</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Employer Contact:<span class="req-text">*</span></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <select class="form-control" v-model="addJob.employer_contact" name="employer contact">
                                            <option value="" disabled>Select Employer Contact</option>
                                            <option v-for="(user,idx) in employer_users" :key="idx" :value="user.user_id"> {{ user.user.first_name }}</option>
                                        </select>
                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                    </div>
                                    
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Venue:<span class="req-text">*</span></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                            <el-select v-model="addJob.venue_id" filterable placeholder="Select Venue" style="width: 100%;">
                                                <el-option
                                                v-for="venue in dropdownVenues"
                                                :key="venue.id"
                                                :label="venue.name"
                                                v-validate="'required'"
                                                :value="venue.id">
                                                </el-option>
                                                <span class="err-msg">{{ errors.first('venue') }}</span>
                                            </el-select>                                    
                                        </div>                                
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Start Date:<span class="req-text">*</span></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <div class="row">
                                            <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <el-col :span="50">
                                                    <el-date-picker
                                                    type="date"
                                                    :placeholder="getDatePlaceholder()"
                                                    style="width: 100%;"
                                                    v-validate="'required'"
                                                    name="start"
                                                    v-model="addJob.start"
                                                    :format="getDisplayFormat()"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    >
                                                    </el-date-picker>
                                                    <span class="err-msg">{{ errors.first('start') }}</span>
                                                </el-col>
                                                </label>
                                                
                                            </div>
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">End Date:<span class="req-text">*</span></label>
                                            </div>
                                            <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <el-col :span="50">
                                                    <el-date-picker
                                                    type="date"
                                                    :placeholder="getDatePlaceholder()"
                                                    style="width: 100%;"
                                                    v-validate="'required'"
                                                    name="end"
                                                    v-model="addJob.end"
                                                    :format="getDisplayFormat()"
                                                    :picker-options="pickerOptions"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    >
                                                    </el-date-picker>
                                                    <span class="err-msg">{{ errors.first('end') }}</span>
                                                </el-col>  
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Employer Request:</label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                        <vue-editor 
                                            id="editor1" 
                                            class="c-common-box-shadow c-radius3" 
                                            :class="{ 'error-border': hasError }"
                                            v-model="addJob.employer_requesting" 
                                            style="height: 220px;"
                                            @text-change="validateContent('employer_requesting', addJob.employer_requesting)"
                                        ></vue-editor>
                                        <span 
                                            v-if="error.employer_requesting && error.employer_requesting.hasError" 
                                            class="err-msg"
                                        >
                                            {{ error.employer_requesting.message }}
                                        </span>


                                    </div>
                                </div>
                            </div>

                            <div v-if="modalType=='add'" class="row">
                                <div class="col-sm-12 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Documents:</label>
                                    </div>
                                    <div class="col-sm-8 o-left-no-padding o-modal-form-field no-right-padding">
                                        <div v-for="(file, key) in new_files" :key="key" class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                            <button class="btn c-common-btn c-common-btn--small">Choose File</button>
                                            <input @change="addFileForAddNewJob($event,key)" type="file" name="myfile" />
                                            <span class="addJobTypeArea">
                                                <span class="addJob-title">{{snippet(new_files[key].name)}}</span>
                                                <span v-if="file.selected == true" class="addJob-drop">
                                                    <div class="o-cutsomSelect o-cutsomSelect--inline o-custom-drop add-job-drop-type">
                                                        <select v-model="new_files[key].label">
                                                            <option value="Report">Report</option>
                                                            <option value="HW">HW</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                </span>
                                            </span>
                                            <a href="javascript: void(0)" v-if="new_files.length >1" @click="removeFile(key)" class="o-choose-del-btn">
                                                <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-sm-1 o-right-no-padding o-modal-form-field o-job-add-icon">
                                        <label class="common-label-text common-label-text--modalwidth">
                                            <a href="javascript: void(0)" @click="cloneInputfile()" class="o-choose-add-btn">
                                                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                            </a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a 
                                        href="javascript: void(0)" 
                                        @click="closeAddJob()" 
                                        data-dismiss="modal" 
                                        aria-label="Close" 
                                        class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" 
                                    v-if="modalType=='add'" 
                                    @click="addNewJob()" 
                                    class="c-solid-btn c-solid-btn--large c-solid-btn--green">
                                    <i class="fa fa-plus" aria-hidden="true"></i> 
                                        Add Job
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>    
                </div>
            </div>
        </modal>

        <modal name="add-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom" width="100%">
            <div tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header text-center">
                            <button 
                                @click="closeAddJob()" 
                                type="button" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h1 class="modal-title">Add New Job</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <form>
                                <div class="row" gutter="30" >
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Event Name:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                            <input 
                                                type="text" 
                                                id="event-name" 
                                                class="form-control" 
                                                placeholder="Event Name" 
                                                v-validate="{ required: true}" 
                                                name="Event" v-model="addJob.title">
                                                <span v-show="errors.has('Event') && this.validation_err!=0" class="err-msg">
                                                    {{ errors.first('Event') }}
                                                </span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Start Date:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-5 o-modal-form-field">
                                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-col :span="50">
                                                            <el-date-picker
                                                            type="date"
                                                            :placeholder="getDatePlaceholder()"
                                                            style="width: 100%;"
                                                            v-validate="{required: true}"
                                                            name="StartAddDate"
                                                            v-model="addJob.start"
                                                            :format="getDisplayFormat()"
                                                            value-format="yyyy-MM-dd"
                                                            >
                                                            </el-date-picker>
                                                            <span v-show="errors.has('StartAddDate') && this.validation_err!=0" class="err-msg">{{ errors.first('StartAddDate') }}</span>
                                                            </el-col>
                                                    </label>
                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">End Date:<sup>*</sup></label>
                                                </div>
                                                <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-col :span="50">
                                                            <el-date-picker
                                                            type="date"
                                                            :placeholder="getDatePlaceholder()"
                                                            style="width: 100%;"
                                                            v-validate="{ required: true}"
                                                            name="end"
                                                            v-model="addJob.end"
                                                            :format="getDisplayFormat()"
                                                            :picker-options="pickerOptions"
                                                            value-format="yyyy-MM-dd">
                                                            </el-date-picker>
                                                            <span v-show="errors.has('end') && this.validation_err!=0" class="err-msg">{{ errors.first('end') }}</span>
                                                        </el-col>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-loading="modalDataLoad">
                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Location:<sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <select 
                                                        v-validate="'required'" @blur="blur($event)" 
                                                        @change="addLocationDetails(addJob.venue_id)" 
                                                        v-model="addJob.venue_id" 
                                                        class="form-control" 
                                                        name="Location" 
                                                        data-vv-delay="500"
                                                    >
                                                        <option value="">--- Select ---</option>
                                                        <option v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    <span v-show="errors.has('Location') && this.validation_err!=0" class="err-msg">{{ errors.first('Location') }}</span>
                                                </label>
                                                <span 
                                                    v-if="getPower('addVenue')"
                                                >
                                                    <a href="javascript: void(0)" 
                                                    @click="addVenueAddress()" 
                                                    class="fl-right">
                                                    <i class="fa fa-plus" aria-hidden="true"></i> 
                                                    Add Venue</a>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Location Details:</label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <textarea v-model="addJob.location_details" class="form-control" rows="2" placeholder="Text Area"></textarea>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Employer: <sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <div class="row">
                                                    <div class="col-sm-5 o-right-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <select 
                                                                @blur="blur($event)" 
                                                                @change="addEmployerContact(addJob.hiring_organization_id)" 
                                                                v-model="addJob.hiring_organization_id" class="form-control" 
                                                                v-validate="{ required: true}" name="Employer" 
                                                                data-vv-delay="500"
                                                            >
                                                                <option value="">--- Select ---</option>
                                                                <option 
                                                                    v-for="(employer,index) in employers" :key="index" 
                                                                    :value="employer.employer_id">
                                                                    {{employer.employer.name}}
                                                                </option>
                                                            </select>
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            <span v-show="errors.has('Employer') && this.validation_err!=0" class="err-msg">{{ errors.first('Employer') }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                                    </div>
                                                    <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <select @blur="blur($event)" v-model="addJob.payroll_id" class="form-control" name="Payroll" data-vv-delay="500">
                                                                    <option value="">--- Select ---</option>
                                                                    <option v-for="(payroll,index) in payrolls" :key="index" :value="payroll.payroll_id">{{payroll.name}}</option>
                                                            </select>
                                                            
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Employer Contact:</label>
                                                
                                            </div>
                                            <div class="col-sm-9 o-modal-form-field">
                                                <div class="row">
                                                    <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                            <select 
                                                                @blur="blur($event)" 
                                                                v-model="addJob.employer_contact" 
                                                                class="form-control" 
                                                                name="employer_contact" 
                                                                data-vv-delay="500"
                                                            >
                                                                <option value="">--- Select ---</option>
                                                                <option v-for="(user,index) in employer_users" :key="index" :value="user.user.id">
                                                                    {{user.user.first_name}}
                                                                </option>                                                                
                                                            </select>
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">HTS:<!-- <sup>*</sup> --></label>
                                                    </div>
                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">                                                        
                                                            <el-switch
                                                                style="display: block"
                                                                v-model="addJob.hts_flag"
                                                                active-color="#13ce66"
                                                                inactive-color="#dcdfe6"
                                                                :active-value=1
                                                                :inactive-value=0                                              
                                                                >
                                                            </el-switch>                                                        
                                                        </div>                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Steward:<sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-9 o-right-no-padding o-modal-form-field">
                                                <div class="row">
                                                    <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <el-select 
                                                                v-model="addJob.employee_id" 
                                                                filterable 
                                                                placeholder="Select Steward" 
                                                                @blur="blur($event)" 
                                                                v-validate="{ required: true}" 
                                                                name="steward" 
                                                                data-vv-delay="500"
                                                            >
                                                                <el-option
                                                                    v-for="(steward,index) in stewards"
                                                                    :key="index"
                                                                    :label="steward.last_name+', '+steward.first_name"
                                                                    v-validate="'required'"
                                                                    :value="steward.id">
                                                                </el-option>
                                                            </el-select>
                                                           
                                                            <span v-show="errors.has('steward') && this.validation_err!=0" class="err-msg">
                                                                {{ errors.first('steward') }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-4 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">Deny Steward Access:<sup>*</sup></label>
                                                    </div>

                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">                                                        
                                                        <el-switch
                                                        style="display: block"
                                                        v-model="addJob.steward_access_flag"
                                                        active-color="#13ce66"
                                                        inactive-color="#dcdfe6"
                                                        :active-value=0
                                                        :inactive-value=1                                               
                                                        >
                                                        </el-switch>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Dispatched by:<sup>*</sup></label>
                                            </div>

                                            <div class="col-sm-9 o-modal-form-field">
                                                <div class="row"> 

                                                    <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            
                                                            <el-select 
                                                                v-model="addJob.dispatched_by" 
                                                                @blur="blur($event)" 
                                                                filterable 
                                                                placeholder="Select Steward" 
                                                                v-validate="{ required: true}" 
                                                                name="createdBy" 
                                                                data-vv-delay="500"
                                                            >
                                                                <el-option
                                                                    v-for="(steward,index) in dispatchedList"
                                                                    :key="index"
                                                                    :label="steward.last_name+', '+steward.first_name"
                                                                    :value="steward.user_id">
                                                                </el-option>
                                                            </el-select>
                                                            
                                                            <span v-show="errors.has('createdBy') && this.validation_err!=0" class="err-msg">
                                                                {{ errors.first('createdBy') }}
                                                            </span>
                                                        </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-sm-3 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">Link Color:<sup>*</sup></label>
                                                    </div>
                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <el-color-picker v-model="addJob.link_color"></el-color-picker>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>   
                                    </div>

                                    <div class="row" v-if="global_skills">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-modal-form-field o-right-no-padding">
                                                <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                    <label class="common-label-text common-label-text--modalwidth">Global Skills: </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <select @blur="blur($event)" v-model="addJob.skill_id1" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                        <option value="" label="--- Select ---"></option>
                                                        <option 
                                                            v-for="(position,index) in positions" 
                                                            :value="position.id" 
                                                            :key="index" 
                                                            :disabled="isDuplicated(position.id)">
                                                            {{position.name}}
                                                        </option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            
                                                </div>
                                                <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <select @blur="blur($event)" v-model="addJob.skill_id2" class="form-control" data-vv-delay="500" v-if="positions.length">
                                                        <option value="" label="--- Select ---"></option>
                                                        <option 
                                                            v-for="(position,index) in positions" 
                                                            :value="position.id" :key="index" 
                                                            :disabled="isDuplicated(position.id)">
                                                                {{position.name}}
                                                            </option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                                <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <select @blur="blur($event)" v-model="addJob.skill_id3" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                        <option value="" label="--- Select ---"></option>
                                                        <option v-for="(position,index) in positions" 
                                                            :value="position.id" :key="index" 
                                                            :disabled="isDuplicated(position.id)"
                                                        >
                                                            {{position.name}}
                                                        </option>
                                                        
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                                <div class="col-sm-1 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-12">                                   
                                                        
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Employer Requests:</label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                            
                                                <vue-editor 
                                                    id="editor2" 
                                                    class="c-common-box-shadow c-radius3" 
                                                    :class="{ 'error-border': hasError }"
                                                    v-model="addJob.employer_requests" 
                                                    style="height: 220px;"
                                                    @text-change="validateContent('employer_requests', addJob.employer_requests)"
                                                ></vue-editor>
                                                <span 
                                                    v-if="error.employer_requests && error.employer_requests.hasError" 
                                                    class="err-msg"
                                                >
                                                    {{ error.employer_requests.message }}
                                                </span>


                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Comments:</label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                                
                                                <vue-editor 
                                                    id="editor3" 
                                                    class="c-common-box-shadow c-radius3" 
                                                    :class="{ 'error-border': errors.comment && errors.comment.hasError }"
                                                    v-model="addJob.comment" 
                                                    style="height: 220px;"
                                                    @text-change="validateContent('comment', addJob.comment)"
                                                ></vue-editor>
                                                <span 
                                                    v-if="error.comment && error.comment.hasError" 
                                                    class="err-msg"
                                                >
                                                    {{ error.comment.message }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field o-common-margin-bottom15">
                                                <div class="o-pub">
                                                    <label class="o-blue-medium-text">Hide in Calender:</label>
                                                    <div class="toggle-btn">
                                                        <el-switch
                                                        style="display: block"
                                                        v-model="addJob.employer_requests_private"
                                                        active-color="#13ce66"
                                                        inactive-color="#dcdfe6"
                                                        :active-value=1
                                                        :inactive-value=0                                                
                                                        >
                                                        </el-switch>
                                                    </div>
                                                    <label class="o-blue-medium-text o-left-padding-10"> Print With Sign in Sheet:</label>
                                                    <div class="toggle-btn">
                                                        <el-switch
                                                        style="display: block"
                                                        v-model="addJob.employer_requests_signin"
                                                        active-color="#13ce66"
                                                        inactive-color="#dcdfe6"
                                                        :active-value=1
                                                        :inactive-value=0                                                
                                                        >
                                                        </el-switch>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-12 o-modal-field-area o-common-margin-bottom15">
                                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                                </div>
                                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <sup>*</sup> Comments- ALWAYS printed with sign-in and calendar info !
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Documents:</label>
                                        </div>
                                        <div class="col-sm-8 o-left-no-padding o-modal-form-field no-right-padding">
                                            <div v-for="(file, key) in new_files" :key="key" class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                <button class="btn c-common-btn c-common-btn--small">Choose File</button>
                                                <input @change="addFileForAddNewJob($event,key)" type="file" name="myfile" />
                                                <span class="addJobTypeArea">
                                                    <span class="addJob-title">{{snippet(new_files[key].name)}}</span>
                                                    <span v-if="file.selected == true" class="addJob-drop">
                                                        <div class="o-cutsomSelect o-cutsomSelect--inline o-custom-drop add-job-drop-type">
                                                            <select v-model="new_files[key].label">
                                                                <option value="Report">Report</option>
                                                                <option value="HW">HW</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </div>
                                                    </span>
                                                </span>
                                                <a v-if="new_files.length >1" @click="removeFile(key)" class="o-choose-del-btn">
                                                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-sm-1 o-right-no-padding o-modal-form-field o-job-add-icon">
                                            <label class="common-label-text common-label-text--modalwidth">
                                                <a @click="cloneInputfile()" class="o-choose-add-btn">
                                                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                                </a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <button 
                                        @click="closeAddJob()" 
                                        type="button" 
                                        class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue" 
                                        data-dismiss="modal" aria-label="Close"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        type="button" 
                                        class="btn c-solid-btn c-solid-btn--large c-solid-btn--green" 
                                        @click="addSingleJob()">
                                        <i class="fa fa-plus" aria-hidden="true"></i> 
                                        Add Job
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="venue-edit-address"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeEditVenueAddress()"
                                type="button" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Edit Address</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Name:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" class="form-control" placeholder="Type Name" v-model="address.name" v-validate="{ required: true}" name="name">
                                        <span v-show="errors.has('name') && this.validation_err!=0" class="err-msg">{{ errors.first('name') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Street:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" class="form-control" placeholder="Type Address" v-model="address.address" v-validate="{ required: true}" name="address">
                                        <span v-show="errors.has('address') && this.validation_err!=0" class="err-msg">{{ errors.first('address') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">City/Town:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" 
                                            class="form-control" placeholder="Type City/Town" 
                                            v-model="address.municipality" v-validate="{ required: true}" name="municipality">
                                            <span v-show="errors.has('municipality') && this.validation_err!=0" class="err-msg">
                                                {{ errors.first('municipality') }}
                                            </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">State/Province:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" class="form-control" placeholder="Type State/Province" v-model="address.state_province" v-validate="{ required: true}" name="state_province">
                                        <span v-show="errors.has('state_province') && this.validation_err!=0" class="err-msg">{{ errors.first('state_province') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Postal Code:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <!-- #1547 — type="text", NOT "number". A number input physically cannot accept
                                             "V6B 1A1": the browser discards the letters before v-model ever sees
                                             them, so the country-aware API rule shipped for this issue was never
                                             reached from the venue EDIT form. Every other postcode input in the app
                                             (12 of them) is already type="text"; this was the only outlier, which is
                                             why the original report was "create works, edit doesn't". -->
                                        <input type="text" class="form-control" placeholder="Type Postal Code" v-model="address.postcode" v-validate="{ required: true}" name="postcode">
                                        <span v-show="errors.has('postcode') && this.validation_err!=0" class="err-msg">{{ errors.first('postcode') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Country:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" class="form-control" placeholder="Type Country" v-model="address.country" v-validate="{ required: true}" name="country">
                                        <span v-show="errors.has('country') && this.validation_err!=0" class="err-msg">{{ errors.first('country') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeEditVenueAddress()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="editVenueUpdate()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                            </li>
                        </ul>
                    </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
            </div>
        </modal>

        <modal name="calender-details" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header text-center">
                            <h1 class="modal-title">Is this location correct?</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender">
                            <div class="row">
                                <div class="col-sm-12 o-no-padding o-calender-container">

                                    <div class="col-md-7 o-calender-area">
                                        
                                        <div class="custom-row u-common-box-shadow c-radius3">
                                            <div class="o-calls-table">
                                                <div class="o-common-head">
                                                    <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> Venue: {{full_address_map}}</h5>
                                                </div>
                                                <div class="o-map-conatiner">
                                                    <!-- #1715 — interactive pin (replaces the read-only Google embed).
                                                         Seeded with the saved coords so the relocated pin shows. -->
                                                    <VenuePinMap
                                                        v-if="showVerify"
                                                        :lat="address.lat"
                                                        :lng="address.lng"
                                                        :source="address.coords_source"
                                                        :address="full_address_map"
                                                        :draggable="pinDraggable"
                                                        :zoom="17"
                                                        @update:coords="onCoords" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <button
                                        @click="closeMap()"
                                        type="button"
                                        class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                        data-dismiss="modal"
                                        aria-label="Close">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                        Cancel
                                    </button>
                                </li>
                                <template v-if="!pinDraggable">
                                    <li>
                                        <button @click="confirmPin()" type="button" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-check" aria-hidden="true"></i> That's correct</button>
                                    </li>
                                    <li>
                                        <button @click="enableMovePin()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-arrows" aria-hidden="true"></i> Move pin</button>
                                    </li>
                                </template>
                                <li v-else>
                                    <button @click="confirmPin()" type="button" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-check" aria-hidden="true"></i> Save this location</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import { VueEditor } from 'vue2-editor';
import { findContentProblems, describeContentProblems, stripHtml } from '../../contentRules.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import VenuePinMap from './VenuePinMap.vue'; // #1715 interactive pin editor
    export default {

        components: {
            VueEditor,
            VenuePinMap
        },

        data() {            
            const dataProps =  {
                positions: [],
                addJob: {
                    title: '',
                    hiring_organization_id: '',
                    payroll_id: '',
                    employer_contact: '',
                    link_color: '#335479',
                    employee_id: '',
                    created_by: '',
                    dispatched_by: '',
                    start: '',
                    end: '',
                    venue_id: '',
                    location_details: '',
                    employer_requests: '',
                    employer_requesting: '',
                    employer_requests_private: '',
                    employer_requests_signin: '',
                    comment: '',
                    comment_private: '',
                    hts_flag: 0,
                    steward_access_flag:false,
                    skill_id1: "",
                    skill_id2: "",
                    skill_id3: "",
                    client: ''
                },
                clients: [],
                modalDataLoad:false,
                employers: [],
                payrolls: [],
                stewards: [],
                dispatchedList: [],
                employer_users:[],
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
                getDates: function() {
                    return {
                        jobStart: new Date(dataProps.addJob.start).setDate(new Date(dataProps.addJob.start).getDate() - 1)
                    };
                },
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart);
                    }
                },
                loading:false,
                afterApi:false,
                venues: [],
                dropdownVenues: [],
                timeout: null,
                allVenue:[],
                searchData:'',
                storeMore:[],
                next_page:'',
                validation_err: 0,
                address: {
                    "name": "",
                    "address": "",
                    "municipality": "",
                    "state_province": "",
                    "country": "",
                    "postcode": "",
                    "client_id": "",
                    "venueID": "",
                    'status': 0,
                    "lat": null,
                    "lng": null,
                    "coords_source": null,
                    "coords_verified": false,
                },
                venueVerify:0,
                fetchFlag:false,
                full_address_map:'',
                pinDraggable:false, // #1715
                showVerify:false,   // #1715
                global_skills: null,
                clientData: null,
                newJobId: '',
                modalType: 'add',
                hasError: false,
                error: {},
            };
            return dataProps;

        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userRoleSlug: 'userRoleSlug',
                userID: 'userID',
                companyId: 'companyId',
                userFullName: 'userFullName'
            }),
            
        },
        methods: {
            async getClientData() {   
                await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.global_skills = this.clientData.global_skills;
                }).catch((err) => {
                    console.log(err);
                });
            },

            isDuplicated(id) {
                if(this.addJob.skill_id1 != "" && id == this.addJob.skill_id1) {
                    return true;
                }
                else if(this.addJob.skill_id2 != "" && id == this.addJob.skill_id2) {
                    return true;
                }
                else if(this.addJob.skill_id3 != "" && id == this.addJob.skill_id3) {
                    return true;
                }
                return false;               
            },

            async getDropdownVenues() {
                if(this.userRoleSlug == 'employer' || this.userRoleSlug == 'employer-admin') {
                    await service.get('getVenuesList', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'employer-id': this.companyId,
                        'cs3-context-clientId': this.addJob.client
                    })
                    .then((venues) => {
                        let resVenues = venues.data.result;
                        console.log(resVenues);
                        let venuesList = [];
                        resVenues.forEach((obj) => {
                            if(obj.addresses&&obj.addresses.length) {
                                venuesList.push(obj);
                            }
                        })
                        this.dropdownVenues = venuesList;
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            async openAddJob(venue) {
                this.modalDataLoad=true;
                this.$modal.show("add-employer-job");
                this.addJob.venue_id = '';
                this.addJob.client = '';
                this.modalType='add';
                this.addJob.created_by=this.userID;
                await service.get('employer/'+this.companyId+'/getEmployerClientAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                })
                .then((res) => {
                    this.clients = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                await this.addEmployerContact(this.companyId);
                this.modalDataLoad=false;
            },

            addNewJob(){
              this.$validator.validateAll().then((result) => {

                if (result) {
                    this.validateContent('employer_requesting', this.addJob.employer_requesting);
                    if (this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return;
                    }
                    let fromData = {
                        title: this.addJob.title,
                        client_id: this.addJob.client,
                        payroll_id: this.addJob.payroll,
                        created_by: this.addJob.created_by,
                        start: this.addJob.start,
                        end: this.addJob.end,
                        venue_id: this.addJob.venue_id,
                        employer_requests: this.addJob.employer_requesting,
                        employer_contact: this.addJob.employer_contact
                    };

                  service.post('employerjob', fromData, {
                      'Authorization': this.userToken,
                      'cs3-context-role': this.userRole,
                      'employer-id': this.companyId,
                  }).then((res) => {
                      this.newJobId=res.data.result.id;
                      this.uploadImage();
                      this.$modal.hide("add-job");
                      this.$notify({
                          title: this.$t('success'),
                          message: 'Job Added Successfully.',
                          type: 'success'
                      });
                      this.$modal.hide("add-employer-job");
                      this.getJob();
                  }).catch((err) => {
                      console.log(err);
                  });
                }else{
                
                }
              });
            },

            addJobModal(venue) {                
                this.addJob.venue_id = ''
                this.addJob.created_by = this.userID;
                this.modalDataLoad=true;
                service.get('getAllVenue', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((venues) => {
                    let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.dropdownVenues = venuesList;
                }).catch((err) => {
                    console.log(err);
                });
                service.get('employee/getEmployeesByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employees) => {
                    this.employees = employees.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                service.get('employer/'+this.userClientID+'/getClientEmployerAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employers) => {
                    this.employers = employers.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                service.get('payroll/getPayrollByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((payrolls) => {
                    this.payrolls = payrolls.data.result.data;

                }).catch((err) => {
                    console.log(err);
                });

                service.get('employee/getStewards', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.stewards = stewards.data.result;
                    this.modalDataLoad=false;
                    if(this.stewards && this.stewards.length) {
                        let index = this.stewards.findIndex((item)=> item.user_id == this.userID);
                        if(index>=0) {
                            this.addJob.employee_id=this.stewards[index].id;
                        }else{
                            this.addJob.employee_id=""
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });

                service.get('employee/getDispatchedByList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.dispatchedList = stewards.data.result;
                    this.modalDataLoad = false;
                    let index = this.dispatchedList.findIndex((item)=> item.user_id == this.userID); 
                    if(index>=0){
                        this.addJob.dispatched_by = this.userID;
                    }
                    else{
                        this.addJob.dispatched_by = ""
                    }                   
                }).catch((err) => {
                    console.log(err);
                })

                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((skills) => {
                    this.positions = skills.data.result;
                }).catch((err) => {
                    console.log(err);
                });

                this.addJob.title = '';
                this.addJob.hiring_organization_id = '';
                this.addJob.payroll_id= '';
                this.addJob.link_color = '#335479';
                this.addJob.start = '';
                this.addJob.end = '';
                this.addJob.venue_id = venue.id,
                this.addJob.location_details = '';
                this.addJob.employer_requests = '';
                this.addJob.employer_requests_private = '';
                this.addJob.employer_requests_signin = '';
                this.addJob.comment = '';
                this.addJob.comment_private = '';
                this.addJob.skill_id1 = '';
                this.addJob.skill_id2 = '';
                this.addJob.skill_id3 = '';

                this.$modal.show("add-job");
                this.addLocationDetails(venue.id);
                setTimeout(function (){
                    $('#event-name').focus();
                }, 500);
                
            },

            addSingleJob() {
                if(this.userRoleSlug=='' || this.userRoleSlug=='') {
                    this.addNewJob();
                } else {
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.validation_err = 0;
                            this.validateContent('employer_requests', this.addJob.employer_requests);
                            this.validateContent('content', this.addJob.content);
                            if (this.hasValidationErrors()) {
                                this.$notify.error({
                                    title: 'Error', 
                                    message:'Please fix validation errors before saving.'}
                                ); 
                                return; // Stop the save process
                            }
                            let fromData = {
                                user_id: this.userID,
                                title: this.addJob.title,
                                employer_id: this.addJob.hiring_organization_id,
                                payroll_id: this.addJob.payroll_id,
                                employer_user_id: this.addJob.employer_contact,
                                link_color: this.getColor(this.addJob.link_color),
                                employee_id: this.addJob.employee_id,
                                created_by: this.addJob.created_by,
                                dispatched_by: this.addJob.dispatched_by,
                                start: this.addJob.start + " " + Date().slice(16, 24),
                                end: this.addJob.end + " " + Date().slice(16, 24),
                                venue_id: this.addJob.venue_id,
                                location_details: this.addJob.location_details,
                                employer_requests: this.addJob.employer_requests,
                                employer_requests_private: this.addJob.employer_requests_private,
                                employer_requests_signin: this.addJob.employer_requests_signin,
                                comment: this.addJob.comment,
                                comment_private: (this.addJob.comment_private) ? 1 : 0,
                                serial: '',
                                label: this.addJob.label,
                                hts_flag: this.addJob.hts_flag,
                                steward_access_flag: this.addJob.steward_access_flag,
                                skill_id1: this.addJob.skill_id1 == "" ? null:this.addJob.skill_id1,
                                skill_id2: this.addJob.skill_id2 == "" ? null:this.addJob.skill_id2,
                                skill_id3: this.addJob.skill_id3 == "" ? null:this.addJob.skill_id3,
                            };
                            service.post('job', fromData, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID
                            }).then((res) => {
                                this.newJobId=res.data.result.id;
                                this.uploadImage();
                                this.$modal.hide("add-job");
                                this.modalDataLoad=false;
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Job Added Successfully.',
                                    type: 'success'
                                });
                                this.$modal.hide("add-job");
                            }).catch((err) => {
                                console.log(err);
                            });
                        } else {
                            this.validation_err = 1;
                            this.$notify.error({
                                title: this.$t('error'),
                                message: 'Please fill up all required fields.'
                            });
                        }
                    });
                }
            },

            getColor(color) {
                var value = color.substr(1);
                return value;
            },

            addFileForAddNewJob(e, index) {                
                var input = e.target;                
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;                            
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                                             
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },

            uploadImage() {
                
                for (var i = 0; i < this.new_files.length; i++) {
                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false && this.new_files[i].selected==true) {                        
                        this.uploadService(this.new_files[i]).then((path) => {                            
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                   
                }
            },

            uploadService(img) {
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name

                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            
                            resolve(res);
                            img.path = res.data.result.path;
                            img.uploaded = true;

                            let activityData = {
                                uploader_id: this.userID,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: this.newJobId,
                                created_by: this.employeeId,
                                attachable_type: 'job',
                                filename: img.name,
                                description: 'Job Document',
                                label: img.label,
                                path: img.path,
                                activity: JSON.stringify(activityData)
                            }
                            service.post('attachment', fromData, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID
                            })
                            .then((res) => {
                                
                            }).catch((err) => {
                                 console.log('Error');
                            });

                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;
            },

            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },

            removeFile(key) {
                this.new_files.splice(key, 1);
            },

            snippet(value) {
                if (value.length > 15)
                    return value.slice(0, 15) + '  ...';
                else
                    return value;
            },

            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                return format?format:'MM/dd/yyyy';
            },

            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },

            async addEmployerContact(id) {
                await service.get('employer/'+id+'/getAllEmployerUsersListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    let self =this;
                    this.employer_users=res.data.result.employer_users;
                    this.employer_users.forEach(function(user) {
                        if(user.user.role.name == 'Employer Admin'){
                            self.addJob.employer_contact = user.user.id;
                        }
                    });
                }).catch((err) => {
                    console.log(err);
                })
            },

            addLocationDetails(id) {
                var index = this.venues.findIndex(venue => venue.id == id);
                if (index != -1) {
                    this.addJob.location_details = (this.venues[index].addresses) ? this.venues[index].addresses[0].address : "NA";
                }
            },
            closeAddJob() {
                this.$modal.hide("add-job");
                this.$modal.hide("add-employer-job");
            },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            getAddJobPower() {                
                if((this.isSteward ==1 && this.userRoleSlug=='employee') || this.userRoleSlug=='power-user') {
                    return true;
                } else if(this.userRoleSlug=='employer' || this.userRoleSlug=='employer-admin') {
                    return true;
                }
                return false;
            },
            closeMap() {
                this.showVerify = false;   // #1715
                this.pinDraggable = false; // #1715
                this.$modal.hide("calender-details");
            },
            // #1715 — pin editor: track the marker's coords + source as the user
            // confirms or drags it.
            onCoords({ lat, lng, source }) {
                this.address.lat = lat;
                this.address.lng = lng;
                this.address.coords_source = source;
            },
            // #1715 — "Move pin": make the marker draggable so the dispatcher can nudge it.
            enableMovePin() {
                this.pinDraggable = true;
            },
            // #1715 — "That's correct" / "Save this location": a human has confirmed
            // the pin, so mark it verified and save. Source is already 'geocoded'
            // (accepted) or 'manual' (dragged) from onCoords.
            confirmPin() {
                this.address.coords_verified = true;
                this.saveUpdate();
            },
            getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},
            deleteVenueSingle(id) {
                this.$confirm('VENUE will be removed from the records of VENUE LIST. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    service.del('venue/' + id, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                       
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Venue Deleted Successfully.',
                            type: 'success'
                        });
                        this.getVenueList();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            
            async getVenueList() {
                let self = this;
                this.$Progress.start();
                this.loading=true;
                this.afterApi=false;
                if(this.userRoleSlug=='employer-admin' || this.userRoleSlug=='employer'){
                    await service.get('getPaginatedVenuesList', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'employer-id': this.companyId,
                        
                        'search': this.searchData,
                    }).
                    then(async (res) => {
                        this.venues = res.data.result.data; // employer
                        this.loading=false;
                        this.afterApi=true;
                        this.$Progress.finish();
                        this.next_page = res.data.result.next_page_url;
                        if (this.next_page != null || this.next_page == "") {
                            await service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId,
                                'search': this.searchData,
                            }).then((more) => {
                                self.storeMore = more.data.result.data;
                            }).catch((err) => {
                                console.log(err);
                            });
                        }

                    }).catch((err) => {
                        console.log(err);
                        this.loading=false;
                        this.afterApi=true;
                    });    
                }
                else{
                    await service.get('venue', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'search': this.searchData,
                    }).
                    then(async (res) => {
                        this.venues = res.data.result.data;
                        this.loading=false;
                        this.afterApi=true;
                        this.$Progress.finish();
                        this.next_page = res.data.result.next_page_url;
                        if (this.next_page != null || this.next_page == "") {
                            await service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'search': this.searchData,
                            }).then((more) => {
                                this.storeMore = more.data.result.data;
                                this.next_page = more.data.result.next_page_url;
                               
                            }).catch((err) => {
                                console.log(err);
                            });
                        }
                        
                    }).catch((err) => {
                        console.log(err);
                        this.loading=false;
                        this.afterApi=true;
                    });
                }
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {                
                var arr = this.venues;
                if (this.storeMore.length) {
                    this.storeMore.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.storeMore = [];
                    if (this.next_page != null || this.next_page != "") {
                        let header = {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'search': this.searchData,
                        }
                        if(this.userRoleSlug == 'employer' || this.userRoleSlug == 'employer-admin') {
                            header['employer-id'] = this.companyId
                        }else {
                            header['cs3-context-clientId'] = this.userClientID
                        }
                        await service.getUrl(this.next_page, header).then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }else
                        this.storeMore = [];
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },

            editVenueUpdate() {
                let self =this;
                self.$validator.validateAll().then((result) => {
                    if (result) {
                        self.validation_err = 0;
                        this.full_address_map= this.address.name+', '+
                        this.address.address+', '+this.address.municipality+', '
                        +this.address.state_province+', '+this.address.postcode+', '
                        +self.address.country;
                        this.pinDraggable = false; // #1715 open in confirm mode
                        this.showVerify = true;
                        this.$modal.show("calender-details");
                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            saveUpdate(){
                let self = this;
                service.put('venue/' + self.address.venueID, self.address, {
                    'Authorization': self.userToken,
                    'cs3-context-role': self.userRole,
                    'cs3-context-clientId': self.userClientID,
                }).then((res) => {
                    self.showVerify = false;   // #1715
                    self.pinDraggable = false; // #1715
                    setTimeout(() => {
                        self.$modal.hide('venue-edit-address');
                        this.$modal.hide("calender-details");
                    }, 1000);
                    self.$notify({
                        title: this.$t('success'),
                        message: 'Venue updated Successfully.',
                        type: 'success'
                    });
                    self.getVenueList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            editVenueAddress(venue) {
                this.address['status']=1;
                this.$modal.show("venue-edit-address");
                this.address.name = venue.name;
                this.address.address = venue.addresses[0].address;
                this.address.municipality = venue.addresses[0].municipality;
                this.address.state_province = venue.addresses[0].state_province;
                this.address.postcode = venue.addresses[0].postcode;
                this.address.country = venue.addresses[0].country;
                this.address.client_id = this.userClientID;
                this.address.venueID = venue.id;
                this.address.status = (venue.addresses[0].status)? venue.addresses[0].status : 0;
                // #1715 — load the saved pin so the edit shows the relocated marker + coords.
                this.address.lat = (venue.lat != null && venue.lat !== '') ? Number(venue.lat) : null;
                this.address.lng = (venue.lng != null && venue.lng !== '') ? Number(venue.lng) : null;
                this.address.coords_source = venue.coords_source || null;
                this.address.coords_verified = !!venue.coords_verified;
            },
            closeEditVenueAddress() {
                this.$modal.hide("venue-edit-address");
                this.address = {
                    "name": "",
                    "address": "",
                    "municipality": "",
                    "state_province": "",
                    "country": "",
                    "postcode": "",
                    "client_id": "",
                    "venueID": "",
                    "status": 0,
                    "lat": null,
                    "lng": null,
                    "coords_source": null,
                    "coords_verified": false,
                };
            },
            addVenueAddress() {
                this.$router.push({
                    'path': '/addVenue'
                });
            },

            addVenueToEmployerFavorite(venue_id) {
                let self = this;
                let payload = {
                    employer_id: this.companyId,
                    venue_id: venue_id
                }
                service.post('employer/addFavouriteVenue', payload, {
                    'Authorization': self.userToken,
                    'cs3-context-role': self.userRole,
                }).then((res) => {
                    self.$notify({
                        title: this.$t('success'),
                        message: 'Venue added to favorites list Successfully.',
                        type: 'success'
                    });
                    self.getVenueList();
                }).catch((err) => {
                    console.log(err);
                });
            },

            removeVenueFromEmployerFavorite(venue_id) {
                let self = this;
                let payload = {
                    employer_id: this.companyId,
                    venue_id: venue_id
                }
                service.post('employer/removeFavouriteVenue', payload, {
                    'Authorization': self.userToken,
                    'cs3-context-role': self.userRole,
                }).then((res) => {
                    self.$notify({
                        title: this.$t('success'),
                        message: 'Venue added to favorites list Successfully.',
                        type: 'success'
                    });
                    self.getVenueList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            validateContent(fieldName, value) {
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    // #1952 — ed, 2026-09-30: "a, show it". Name every offender and where it
                    // is; never rewrite what the user pasted.
                    const problems = findContentProblems(plainText);
                    if (problems.length > 0) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            problems: problems,
                            message: describeContentProblems(problems)
                        });
                    }
                }
            },
    
            getPlainText(html) {
                return stripHtml(html);   // #1952 — shared, was duplicated in ten files
            },
    
            // #1952 — one shared rule set (src/contentRules.js). This used to carry
            // four patterns inline, duplicated verbatim across ten components; two of
            // them rejected indentation, tabs, ---- dividers and ellipses.
            containsInvalidContent(text) {
                return findContentProblems(text).length > 0;
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
        created() {
            if(this.userRoleSlug != 'employer' && this.userRoleSlug != 'employer-admin'){
                this.getClientData();
            }
        },
        beforeMount() {
            this.getVenueList();
        }

    }
</script>

<style scoped>
    .err-msg {
        margin: 2px;
        color: red
    }
    .address-header{
        display: flex;
        flex-direction: row;
        justify-content: space-between; 
    }

    .venue-remove {
        padding: 2px 6px;
        color: #ffffff!important;
        background-color: #FB8B03!important;
        border-radius: 1%;
    }

    .venue-add {
        padding: 2px 6px;
        color: #ffffff!important;
        background-color: #1AB677!important;
        border-radius: 1%;
    }
    .float-right{
        float: right!important;
    }
    .disabled-background-style {
        background-color: #bbb;
    }
    .o-left-padding-10 {
        padding-left: 10px;
    }
    .c-common-btn2 {
        font-size: 14px;
        font-weight: 400;
        padding: 8px;
        border-radius: 5px;
        display: inline-block;
    }
    .font-plain {
        color: #ffffff!important;
    }
    .o-map-conatiner{
        height: 285px;
    }
</style>
